<div
    class="inner-content bg-white dark:rounded-2xl dark:border-2 dark:border-solid dark:border-contrast-yellow dark:bg-contrast-black"
    ridangoAppTrapFocus>
    <div class="flex-align-center m-4 mb-0 !flex justify-between bg-white dark:bg-contrast-black">
        <h2 class="align-center orb-app-light:font-bold flex-1 text-base font-semibold leading-5">
            {{ 'SAVE_FAVORITE_LOCATION' | translate }}
        </h2>
        <button
            class="text-grey-zambezy"
            [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
            (click)="cancel()"
            mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="m-4 !flex bg-white dark:bg-contrast-black">
        <ng-container>
            <form class="w-full" [formGroup]="form" (ngSubmit)="submit()">
                <mat-form-field class="mt-2 flex w-full" appearance="outline" subscriptSizing="dynamic">
                    <mat-label aria-hidden="true">{{ 'NAME' | translate }}</mat-label>
                    <input
                        matInput
                        formControlName="name"
                        required="true"
                        ridangoInput
                        aria-describedby="favorite-location-name-hint" />
                    <mat-hint
                        class="text-gray-500 dark:text-contrast-yellow"
                        id="favorite-location-name-hint"
                        align="start">
                        {{ form.controls.name.value?.length || 0 }} / {{ maxLength }}
                    </mat-hint>
                    <mat-error *ngIf="form.controls.name.errors?.['required']">
                        {{ 'NAME_REQUIRED' | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.controls.name.errors?.['maxlength']">
                        {{ 'NAME_MAX_LENGTH_REACHED' | translate }}
                    </mat-error>
                </mat-form-field>
                <div class="mt-4 flex">
                    <button
                        class="vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black var-app-light:text-primary orb-app-light:bg-primary orb-app-light:text-black h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                        type="submit">
                        {{ 'SAVE_FAVORITE' | translate }}
                    </button>
                </div>
            </form>
        </ng-container>
    </div>
</div>
